<syslink-title text="User groups"></syslink-title>

<app-user-group-grid
    [permissionKey]="'list'"
    [canUpdate]="false"
    [canDelete]="false"
    storageKey="grid-user-groups"
    [newTab]="false"
>
</app-user-group-grid>